class RememberContainer {
  constructor($location, $q, $window, appConfiguration, appSession) {
    'ngInject';

    this.$location = $location;
    this.$q = $q;
    this.$window = $window;
    this.appSession = appSession;

    this.privacyPolicyUrl = appConfiguration.privacyPolicyURL;
    this.goBackUrl = '/login';
    this.error = '';
    this.loading = false;
    this.success = false;
    this._refUrl = '';
    this._referrerRegex = /\/\/([a-zA-Z0-9-\.]+\.(?:photorank\.me|(?:by\-)?olapic\.com))(?:\/|$)/ig;
  }
  $onInit() {
    this._validateReferrerURL();
  }
  _validateReferrerURL() {
    this.goBackUrl = '/login';
    this._refUrl = '';
    const { referrer } = this.$window.document;
    if (referrer) {
      const matches = this._referrerRegex.exec(referrer);
      if (matches) {
        const [, url] = matches;
        this._refUrl = url;
        this.goBackUrl = `https://${url}`;
      }
    }
  }
  rememberPassword(email) {
    let result;
    if (this.loading) {
      result = this.$q.reject(new Error('The request is in progress'));
    } else {
      this.loading = true;
      result = this.appSession.rememberPassword(email, this._refUrl)
      .then(() => {
        this.success = true;
      })
      .catch((error) => {
        this.error = error.message;
      })
      .then(() => {
        this.loading = false;
      });
    }

    return result;
  }
}

export default {
  controller: RememberContainer,
  template: `
    <remember
      error="$ctrl.error"
      loading="$ctrl.loading"
      success="$ctrl.success"
      on-remember="$ctrl.rememberPassword(email)"
      go-back-url="$ctrl.goBackUrl"
      privacy-policy-url="$ctrl.privacyPolicyUrl"
    />
  `,
};
